import {
  CreateIncidentInput,
  IncidentCategoryOption,
  IncidentTypeOption,
  PriorityOption
} from "@/graphql/generated"

type ActionTypes = 
{ type: 'CREATE_INCIDENT-setProperty', payload: { propertyId: string }}
| { type: 'CREATE_INCIDENT-setUnity', payload: { unityId: string | null }}
| { type: 'CREATE_INCIDENT-setType', payload: { type: IncidentTypeOption }}
| { type: 'CREATE_INCIDENT-setCategory', payload: { category: IncidentCategoryOption }}
| { type: 'CREATE_INCIDENT-setPriority', payload: { priority: PriorityOption }}
| { type: 'CREATE_INCIDENT-setStartDate', payload: { date: string | null }}
| { type: 'CREATE_INCIDENT-setEndDate', payload: { date: string | null }}
| { type: 'CREATE_INCIDENT-setDescriptionNote', payload: { description: string }}
| { type: 'CREATE_INCIDENT-setSupplier', payload: { supplierId: string | null }}
| { type: 'CREATE_INCIDENT-setSubject', payload: { subject: string }}

export const CreateIncidentReducer = (state: CreateIncidentInput, action: ActionTypes) => {
  switch (action.type) {
    case 'CREATE_INCIDENT-setProperty':
    return {
      ...state,
      propertyId: action.payload.propertyId,
    }

    case 'CREATE_INCIDENT-setUnity':
    return {
      ...state,
      unityId: action.payload.unityId,
    }

    case 'CREATE_INCIDENT-setType':
      return {
        ...state,
        incidentType: action.payload.type
      }

    case 'CREATE_INCIDENT-setCategory':
      return {
        ...state,
        incidentCategory: action.payload.category
      }

    case 'CREATE_INCIDENT-setPriority':
      return {
        ...state,
        incidentPriority: action.payload.priority
      }
      
    case 'CREATE_INCIDENT-setStartDate':
      return {
        ...state,
        startDate: action.payload.date,
      }

    case 'CREATE_INCIDENT-setEndDate':
      return {
        ...state,
        endDate: action.payload.date,
      }

    case 'CREATE_INCIDENT-setSupplier':
      return {
        ...state,
        supplierId: action.payload.supplierId
      }

    case 'CREATE_INCIDENT-setDescriptionNote':
      return {
        ...state,
        incidentNote: action.payload.description
      }

    case 'CREATE_INCIDENT-setSubject':
      return {
        ...state,
        subject: action.payload.subject
      }
  }
}
